import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, parseNumber,
    FetchData,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto, deposito_tipo_cambio} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }
    }

    const handleChangeAmount = (event) => {
        const { name, value } = event.target
        
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_tipo_cambio} = formState

        const valueParsed = parseNumber.setNumberMask(value)
        
        const monto = valueParsed.value !== '' ? valueParsed.value : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;
        
        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? value : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }
   

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        
        onResetForm()
        closeModal()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const { FormLeases, FormFiles, FormDeposit } = Forms
        const onResetFormLeases = FormLeases.onResetForm
        const onResetFormFiles = FormFiles.onResetForm
        const onResetFormDeposit = FormDeposit.onResetForm

        onResetFormLeases()
        onResetFormFiles()
        onResetFormDeposit()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickCompleteRequest = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const { FormLeases, FormFiles, FormDeposit } = Forms
        const onResetFormLeases = FormLeases.onResetForm
        const onResetFormFiles = FormFiles.onResetForm
        const onResetFormDeposit = FormDeposit.onResetForm

        const { fetchAllLeaseApplications:{executeFetchAllLeaseApplications} } = FetchData


        onResetFormLeases()
        onResetFormFiles()
        onResetFormDeposit()

        executeFetchAllLeaseApplications()
        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickFetchAllLeases = async () => {

        const { fetchAllLeaseApplications } = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications

        executeFetchAllLeaseApplications()

    }

    const handleClickFetchInfoLease = async (idcontrato) => {
        
        const { FormLeases} = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()
        
        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()

        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('READONLY')

    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickEditLease = async (idcontrato) => {
        
        const { FormLeases} = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()

        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()

        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('EDITABLE')

    }
    
    const handleChangeHouses = (event) => {
        const { FormLeases } = Forms
        const { setFormState } = FormLeases

        const houses = JSON.parse(event.target.value || null)


        if(houses){
            setFormState(prevState => ({
                ...prevState,
                [event.target.name]: event.target.value,
                contrato_costo_alquiler: (houses.costo_alquiler==='') ? 0 : houses.costo_alquiler
            }))
        }else{
            setFormState(prevState => ({
                ...prevState,
                contrato_costo_alquiler: ''
            }))
        }
    }

    const handleClickCleanUpFiles = (event) => {
        const { FormFiles } = Forms
        const { setFormState } = FormFiles

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        executeFetchAllDeposits()

    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles} = FetchData
        const { executeFetchAllFiles } = fetchAllFiles

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
                .then( async ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllFiles()
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }
  
    const handleChangeTotalMonths = (event) => {
        
        const { name, value } = event.target

        const { FormLeases } = Forms
        const { formState ,setFormState } = FormLeases

        const totalAlquiler = (formState.contrato_costo_alquiler * (value || 0))
        const totalParsed = parseNumber.setNumberMask(String(totalAlquiler) || '0')
        
        setFormState({
            ...formState,
            [ name ]: value,
            contrato_total_alquiler: totalParsed.value,
            contrato_total_alquiler_mask: totalParsed.value_mask
        });
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');
    
          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }
    
    }

    const handleClickUpdateAprobacion = async () => {

        const { FormLeases } = Forms
        const { formState } = FormLeases

        const { fetchAllLeaseApplications} = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications

        const _body = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_usuario: user.username,
            aprobacion_observaciones: ''
        }

        await marvarApi.put(`/leases/common/aprobacion-check/${formState.idcontrato}`, _body)
            .then(({ data }) => {
                alertMessage(data)
                executeFetchAllLeaseApplications()
                handleClickHideForm()
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        //HOOKS
        const { fetchAllFiles:{executeFetchAllFiles} } = FetchData
        
        executeFetchAllFiles()
        handleClickNextStep()

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()
      
        const { FormFiles, FormLeases } = Forms
        const { formState, setFormState } = FormFiles
        const formStateLeases = FormLeases.formState

        const {fetchAllFiles, fetchInfoLease} = FetchData
        const {executeFetchAllFiles} = fetchAllFiles

        const { setParamsToSearch, executeFetchInfoLease } = fetchInfoLease
        
        if(formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Debe seleccionar al menos un documento para subir'
            })
            return
        }        

        if(formState.acceptedFiles.length>1){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Solo puede cargar 1 archivo'
            })
            return
        }

        const _data = new FormData();

        _data.append('idcontrato', formStateLeases.idcontrato);
        _data.append('department', 'JURIDICO');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', new Date());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        await marvarApi.post( `/leases/common/create-document`, _data )
            .then(async ({ data }) => { 

                
                if (data.title === 'OK') {
                    setFormState(prevState => ({
                        ...prevState,
                        acceptedFiles : [],
                        fileRejections : []
                    }))
                    executeFetchAllFiles()
                }
                alertMessage(data)

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
    }

    const onSubmitObservationsForm = async (e) => {
    
        e.preventDefault()

        // const { formOpeningMode } = globalStates
        
        const { ObservationsForm, FormLeases } = Forms

        const { fetchAllObservations } = FetchData

        console.log('[useActions][onSubmitObservationsForm] FormLeases.formState ::: ', FormLeases.formState)

        if (FormLeases.formState.idcontrato === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No es posible guardar el comentario, no se puede identificar el contrato a asociar.'
            })
            return
        }

        if (ObservationsForm.formState.log_observacion === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No a escrito nada para agregar como comentario, por favor, revise que su comentario este escrito.'
            })
            return
        }

        const _data = { 
            idcontrato: FormLeases.formState.idcontrato,
            // idcontrato: 3,
            log_departamento: 'GESTIONES',
            log_observacion: ObservationsForm.formState.log_observacion,
            idusuario: user.uid,
            user: user.username
        }

        console.log('[useActions][onSubmitObservationsForm] _data ::: ', _data)

        await marvarApi.post( `/leases/common/save-observation`, _data )
            .then(({ data }) => {

                alertMessage(data)

                fetchAllObservations.setParamsToSearch({
                    idcontrato: parseInt(FormLeases.formState.idcontrato, 10)
                    // idcontrato: parseInt(3, 10)
                })
                fetchAllObservations.executeFetch()

                ObservationsForm.onResetForm()

            }).catch(error => {console.log('API ERROR: ', error)})

    }

    return Object.freeze({
        handleChangeAmount,
        handleChangeExchangeRate,
        handleChangeHouses,
        handleChangeTotalMonths,
        handleChangeTypeCurrency,
        handleClickCleanUpFiles,
        handleClickCloseModal,
        handleClickCompleteRequest,
        handleClickDeleteDocument,
        handleClickEditLease,
        handleClickFetchInfoDeposit,
        handleClickFetchInfoLease,
        handleClickHideForm,
        handleClickNextStep,
        handleClickReturnStep,
        handleClickShowForm,
        handleClickShowModal,
        handleClickDownloadImage,
        handleClickUpdateAprobacion,
        onSubmitFormApplies,
        onSubmitFormFiles,
        onSubmitObservationsForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}